import { LinkPreview } from "@/entities/message/api/link-preview";
import styles from "./link-preview-card.module.css";

const getFallbackIcon = (url: string): string => {
  try {
    const domain = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?sz=64&domain_url=${encodeURIComponent(domain)}`;
  } catch {
    return 'https://via.placeholder.com/64?text=%E2%9A%A0';
  }
};

export const LinkPreviewCard = ({ preview }: { preview: LinkPreview }) => {
  const getHostname = (url: string) => {
    try {
      return new URL(url).hostname;
    } catch {
      return url;
    }
  };

  const fallbackIcon = getFallbackIcon(preview.url);

  return (
    <a
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkPreviewCard}
    >
      <div className={styles.imageWrapper}>
        {preview.image ? (
          <img
            src={preview.image}
            alt={preview.title || "Preview image"}
            className={styles.image}
            loading="lazy"
            onError={(e) => {
              (e.target as HTMLImageElement).src = fallbackIcon;
            }}
          />
        ) : (
          <img
            src={fallbackIcon}
            alt="Site icon"
            className={styles.image}
            loading="lazy"
          />
        )}
      </div>

      <div className={styles.content}>
        {preview.title && <div className={styles.title}>{preview.title}</div>}
        {preview.description && (
          <div className={styles.description}>{preview.description}</div>
        )}
        <div className={styles.url}>{getHostname(preview.url)}</div>
      </div>
    </a>
  );
};